import { DRAFT__DATA_FETCH_START, DRAFT__DATA_FETCH_SUCCESS, DRAFT__DATA_FETCH_ERROR } from '../actions';
const initialState = {
  draftContent: null,
  draftDataLoading: false,
  draftDataError: null
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case DRAFT__DATA_FETCH_START:
      return {
        ...state,
        draftContent: null,
        draftDataLoading: true,
        draftDataError: null
      };
    case DRAFT__DATA_FETCH_SUCCESS:
      return {
        ...state,
        draftContent: action.payload,
        draftDataLoading: false
      };
    case DRAFT__DATA_FETCH_ERROR:
      return {
        ...state,
        draftDataLoading: false,
        draftDataError: action.payload
      };
    default:
      return state;
  }
});